import React from 'react';
import { Box, Typography } from '@mui/material';

const TabTitle = ({ title, subtitle, actions }) => {
  return (
    <Box display="flex" flexDirection="row" width="100%" justifyContent="space-between" alignItems="flex-start" mb={2}>
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        {title && (
          <Typography variant="h6">{title}</Typography>
        )}
        {subtitle && (
          <Typography variant="body1">{subtitle}</Typography>
        )}
      </Box>
      {actions && (
        <Box display="flex" flexDirection="row" alignItems="center" columnGap="10px">
          {actions}
        </Box>
      )}
    </Box>
  );
};

export default TabTitle;

